/** V8: `at fn (file:line:col)`, `at file:line:col`, `at async fn (...)`, `at new Foo (...)`. */
const V8_FRAME = /^at (?:(?:async )?(.+?) \()?(.+?):(\d+):(\d+)\)?$/;
/** Firefox and WebKit: `fn@file:line:col` or `@file:line:col`. */
const GECKO_FRAME = /^(.*?)@(.+?):(\d+):(\d+)$/;
function frame(fn, filename, line, col) {
    return {
        filename,
        function: fn.length > 0 ? fn : '<anonymous>',
        lineno: Number(line),
        colno: Number(col),
        in_app: !/node_modules|node:internal|^node:/.test(filename),
    };
}
/**
 * Parses an `Error.stack` from V8 (Node, Chromium) or Gecko/WebKit browsers into frames,
 * oldest call first as the event format wants. Lines that are not frames (the message) are
 * skipped; an unknown format yields no frames rather than an error.
 */
export function parseStack(stack) {
    if (!stack)
        return [];
    const frames = [];
    for (const raw of stack.split('\n')) {
        const line = raw.trim();
        const v8 = V8_FRAME.exec(line);
        if (v8) {
            frames.push(frame(v8[1] ?? '', v8[2] ?? '', v8[3] ?? '0', v8[4] ?? '0'));
            continue;
        }
        const gecko = GECKO_FRAME.exec(line);
        if (gecko)
            frames.push(frame(gecko[1] ?? '', gecko[2] ?? '', gecko[3] ?? '0', gecko[4] ?? '0'));
    }
    return frames.reverse();
}
//# sourceMappingURL=stack.js.map